import PropTypes from "prop-types";
import FileUploadPreviewList from "components/FileUploadPreviewList";

function parseDocumentLines(rawText = "") {
  return rawText
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [namePart, ...urlParts] = line.split(": ");
      const url = urlParts.join(": ").trim();
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return { label: namePart.trim(), url };
      }
      return null;
    })
    .filter(Boolean);
}

export default function DocumentPreviewList({ tabId, content }) {
  const docs = parseDocumentLines(content);
  if (!docs.length) {
    return <p className="mt-3 text-sm leading-6 text-text-700">{content}</p>;
  }

  const previewItems = docs.map((doc, index) => ({
    id: `doc-${tabId}-${index}`,
    file: {
      name: `${doc.label}.pdf`,
      type: "application/pdf",
    },
    url: doc.url,
  }));

  return (
    <div className="mt-3">
      <FileUploadPreviewList
        items={previewItems}
        showActions
        showProgress={false}
        onOpen={(item) => window.open(item?.url, "_blank", "noopener,noreferrer")}
      />
    </div>
  );
}

DocumentPreviewList.propTypes = {
  tabId: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};
